// @copyright  2026 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    $dir: 'ltr',

    'bank-rule.page.title': 'Bank Rules',
    'bank-rule.page.archived_title': 'Archived Bank Rules',
    'bank-rule.page.search_results': 'Search Results',
    'bank-rule.page.create.title': 'New Bank Rule',
    'bank-rule.page.edit.title': 'Edit Bank Rule',
    'bank-rule.page.search.title': 'Find Bank Rules',
    'bank-rule.page.all': 'All Rules',
    'bank-rule.page.placeholder.search': 'Search rules by name…',

    'bank-rule.button.new': 'New Rule',
    'bank-rule.button.edit': 'Edit',
    'bank-rule.button.archive': 'Archive',
    'bank-rule.button.save': 'Save Rule',
    'bank-rule.button.cancel': 'Cancel',
    'bank-rule.button.preview': 'Preview',
    'bank-rule.button.add_condition': 'Add Condition',
    'bank-rule.button.remove_condition': 'Remove',
    'bank-rule.button.find': 'Find',
    'bank-rule.button.select': 'Select',
    'bank-rule.button.apply_search': 'Apply',
    'bank-rule.button.reset_search': 'Reset',
    'bank-rule.button.bulk_enable': 'Enable',
    'bank-rule.button.bulk_disable': 'Disable',
    'bank-rule.button.bulk_archive': 'Archive',

    'bank-rule.checkbox.all': 'All',
    'bank-rule.checkbox.actions_label': 'Actions',

    'bank-rule.link.show_archived': 'Show Archived',
    'bank-rule.link.show_active': 'Show Active',
    'bank-rule.link.create_first_bank_rule': 'Create your first bank rule',
    'bank-rule.link.retry': 'Retry',

    'bank-rule.field.name': 'Name',
    'bank-rule.field.description': 'Description',
    'bank-rule.field.applies_to': 'Applies To',
    'bank-rule.field.bank_account': 'Bank Account',
    'bank-rule.field.condition_group_operator': 'Match',
    'bank-rule.field.action_type': 'Action',
    'bank-rule.field.priority': 'Priority',
    'bank-rule.field.is_enabled': 'Enabled',

    'bank-rule.applies_to.money_in': 'Money In',
    'bank-rule.applies_to.money_out': 'Money Out',
    'bank-rule.applies_to.both': 'Both',

    'bank-rule.group_operator.and': 'All of the following',
    'bank-rule.group_operator.or': 'Any of the following',

    'bank-rule.action.match_existing': 'Match Existing Transaction',
    'bank-rule.action.create_transaction': 'Create New Transaction',

    'bank-rule.match_existing.title': 'Match strategy',
    'bank-rule.match_existing.strategy.by_reference_equals_field': 'Match by reference / description',
    'bank-rule.match_existing.strategy.by_reference_equals_field_help': 'Look for a book transaction whose reference or description equals the chosen field on the imported line.',
    'bank-rule.match_existing.strategy.open_invoice_by_contact': 'Match an open invoice for a customer',
    'bank-rule.match_existing.strategy.open_invoice_by_contact_help': 'Find the closest open invoice for the chosen customer (by amount and date).',
    'bank-rule.match_existing.strategy.open_bill_by_vendor': 'Match an open bill for a vendor',
    'bank-rule.match_existing.strategy.open_bill_by_vendor_help': 'Find the closest open bill for the chosen vendor (by amount and date).',
    'bank-rule.match_existing.field_label': 'Imported field to compare',
    'bank-rule.match_existing.field.reference': 'Reference',
    'bank-rule.match_existing.field.description': 'Description',
    'bank-rule.match_existing.customer_label': 'Customer',
    'bank-rule.match_existing.vendor_label': 'Vendor',
    'bank-rule.match_existing.choose_contact': 'Select a contact…',

    'bank-rule.create_transaction.title': 'New transaction details',
    'bank-rule.create_transaction.direction': 'Direction',
    'bank-rule.create_transaction.choose_direction': 'Select direction…',
    'bank-rule.create_transaction.split_mode': 'Split across multiple GL accounts',
    'bank-rule.create_transaction.gl_account': 'GL account (contra side)',
    'bank-rule.create_transaction.gl_account_help': 'The bank account is taken from the imported line. This is the offsetting account that the journal entry posts to (e.g. an expense or income account).',
    'bank-rule.create_transaction.choose_gl_account': 'Select an account…',
    'bank-rule.create_transaction.split_lines': 'Split lines',
    'bank-rule.create_transaction.add_split_line': 'Add split line',
    'bank-rule.create_transaction.percentage_placeholder': '%',
    'bank-rule.create_transaction.total_percentage': 'Total: {total}% (must add up to 100)',
    'bank-rule.create_transaction.memo_template': 'Memo template',
    'bank-rule.create_transaction.memo_template_placeholder': '{description}',
    'bank-rule.create_transaction.memo_template_help': 'Placeholders: {description}, {reference}, {amount}, {date}',
    'bank-rule.create_transaction.contact': 'Contact (optional)',
    'bank-rule.create_transaction.no_contact': 'No contact',

    'bank-rule.condition.field.description': 'Description',
    'bank-rule.condition.field.reference': 'Reference',
    'bank-rule.condition.field.amount': 'Amount',
    'bank-rule.condition.field.payee': 'Payee',
    'bank-rule.condition.field.counterparty': 'Counterparty',

    'bank-rule.condition.operator.equals': 'equals',
    'bank-rule.condition.operator.not_equals': 'does not equal',
    'bank-rule.condition.operator.contains': 'contains',
    'bank-rule.condition.operator.not_contains': 'does not contain',
    'bank-rule.condition.operator.starts_with': 'starts with',
    'bank-rule.condition.operator.ends_with': 'ends with',
    'bank-rule.condition.operator.matches_regex': 'matches regex',
    'bank-rule.condition.operator.eq': 'equals',
    'bank-rule.condition.operator.gt': 'greater than',
    'bank-rule.condition.operator.lt': 'less than',
    'bank-rule.condition.operator.gte': 'greater than or equal',
    'bank-rule.condition.operator.lte': 'less than or equal',
    'bank-rule.condition.operator.between': 'between',

    'bank-rule.condition.placeholder.value': 'Value',
    'bank-rule.condition.placeholder.upper_bound': 'Upper bound',

    'bank-rule.preview.title': 'Preview',
    'bank-rule.preview.would_match': 'Would match',
    'bank-rule.preview.would_not_match': 'Would not match',
    'bank-rule.preview.total_matched': '{total} of {evaluated} recent imports would match',
    'bank-rule.preview.empty_state': 'Add at least one condition to preview matches.',
    'bank-rule.preview.no_recent_imports': 'No recent imports to evaluate against.',
    'bank-rule.preview.error_running': 'Could not run preview.',
    'bank-rule.button.preview_action': 'Preview',
    'bank-rule.button.refresh_preview': 'Re-run preview',
    'bank-rule.button.enable_rule': 'Enable',
    'bank-rule.button.disable_rule': 'Disable',

    'bank-rule.badge.matched_via_rule': 'Matched via rule: {rule}',
    'bank-rule.badge.enabled': 'Enabled',
    'bank-rule.badge.disabled': 'Disabled',

    'bank-rule.empty_state.title': 'No rules yet',
    'bank-rule.empty_state.description': 'Create your first bank rule to automate reconciliation of recurring transactions.',
    'bank-rule.empty_state.archived_title': 'No archived rules',
    'bank-rule.empty_state.archived_description': 'Archived rules will appear here.',
    'bank-rule.empty_state.no_results': 'No rules match your search.',

    'bank-rule.label.conditions_count': '{count} condition | {count} conditions',

    'bank-rule.search.filter_tab': 'Filter',
    'bank-rule.search.sort_tab': 'Sort',

    'bank-rule.filter.any': 'Any',
    'bank-rule.filter.enabled_only': 'Enabled only',
    'bank-rule.filter.disabled_only': 'Disabled only',

    'bank-rule.sort.field': 'Sort by',
    'bank-rule.sort.direction': 'Direction',
    'bank-rule.sort.direction_ascending': 'Ascending',
    'bank-rule.sort.direction_descending': 'Descending',
    'bank-rule.sort.default': 'Priority (default)',
    'bank-rule.sort.created_at': 'Created date',

    'bank-rule.error.message.error_loading_page': 'There was an error loading bank rules. ',

    'bank-rule.success.message.bulk_enabled': 'Enabled {count} rule | Enabled {count} rules',
    'bank-rule.success.message.bulk_disabled': 'Disabled {count} rule | Disabled {count} rules',
    'bank-rule.success.message.bulk_archived': 'Archived {count} rule | Archived {count} rules',
    'bank-rule.success.message.created': 'Bank rule created.',
    'bank-rule.success.message.updated': 'Bank rule updated.',
    'bank-rule.success.message.archived': 'Bank rule archived. | Archived {count} rules.',
    'bank-rule.success.message.enabled': 'Rule enabled.',
    'bank-rule.success.message.disabled': 'Rule disabled.',

    'bank-rule.section.conditions': 'Conditions',
};
